export const main = {
    home: {
        link: "Accueil",
        title: "Page d'accueil d'Osteo2ls"
    },
    contact: {
        link:"Contact",
        title: "Page de contact d'Osteo2ls"
    }
}